import {
  IUpdateGameScoreRequest,
  IUpdateGameScoreResponse,
} from "../types/api";

import { ApiResponse } from "../types/api";
import { apiClient, apiRequest } from "./api";

// Auth API calls
export const gameApi = {
  // Me
  addGameLog: async (
    data: IUpdateGameScoreRequest
  ): Promise<IUpdateGameScoreResponse> => {
    return apiRequest(() =>
      apiClient.post<ApiResponse<IUpdateGameScoreResponse>>("/gameLogs/", data)
    );
  },
};
